import {stringTool} from '../../../util/string-tool.js';

export default class RegisterStudentController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $document, $rootScope, students, currentClassRoom, classRooms, moment,
    access,
    StudentService,
    EmployeeService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$document = $document;
    this.$rootScope = $rootScope;
    this.students = students;
    this.currentClassRoom = currentClassRoom;
    this.classRooms = classRooms;
    this.moment = moment;
    this.access = access;
    this.StudentService = StudentService;
    this.EmployeeService = EmployeeService;
    this.StringTool = stringTool;
    this.attendance = {};
    this.employees = [];
    this.date = new Date();
    this.time = moment().format('HH:mm');
    this.isWaiting = false;
    if (this.students.length > 0) {
      this.students.map(student => {
        if (student.senderId) {
          this.isWaiting = true;
        }

        return student;
      });
    }

    if (this.access.attendance && !this.isWaiting) {
      this.canRegisterToOther = true;
      this.loadEmployees();
    }
  }

  loadEmployees() {
    this.EmployeeService.getSchoolCommonRoomActiveEmployees(0, true).then(result => {
      result.map(employee => {
        employee.firstNameValue = employee.firstName.toLowerCase();
        employee.firstNameValue = this.StringTool.escapePolishCharacters(employee.firstNameValue);
        employee.lastNameValue = employee.lastName.toLowerCase();
        employee.lastNameValue = this.StringTool.escapePolishCharacters(employee.lastNameValue);
        return employee;
      });
      this.employees = result;
      this.employees.map(employee => {
        if (Number(employee.id) === this.$rootScope.me.employeeId) {
          this.selectedEmployee = employee;
        }

        return employee;
      });
    });
  }

  querySearch(query) {
    return query ? this.employees.filter(this.createFilterFor(query)) : this.employees;
  }

  createFilterFor(query) {
    let result = true;
    const lowercaseQuery = query.toLowerCase();
    return employee => {
      if (employee.lastNameValue.search(lowercaseQuery) === 0) {
        result = (employee.lastNameValue.search(lowercaseQuery) === 0);
      } else {
        result = (employee.firstNameValue.search(lowercaseQuery) === 0);
      }

      return result;
    };
  }

  register() {
    this.createRegisters(this.students).then(() => {
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Zarejestrowano ucznia')
          .position('bottom right')
          .hideDelay(3000)
      );
      this.$mdDialog.hide();
    }).catch(error => {
      this.$mdDialog.show(
        this.$mdDialog.extendError({
          locals: {error}
        })
      );
    });
  }

  createRegisters(students) {
    this.attendance.date = this.moment(this.date).format('YYYY-MM-DD');
    this.attendance.startTime = this.time;
    this.attendance.classRoomId = this.currentClassRoom.id;
    if (this.selectedClassRoom) {
      this.attendance.classRoomId = this.selectedClassRoom.id;
    }

    if (this.selectedEmployee) {
      this.attendance.employee = this.selectedEmployee.id;
    }

    this.attendance.students = students;
    const studentsId = [];
    const waitingStudentsId = [];
    this.attendance.students.forEach(student => {
      studentsId.push(Number(student.id));
      if (Number(student.waitingStudentId)) {
        waitingStudentsId.push(Number(student.waitingStudentId));
      }
    });
    this.attendance.students = students;
    this.attendance.studentsId = studentsId;
    this.attendance.waitingStudentsId = waitingStudentsId;
    return this.StudentService.addAttendance(this.attendance);
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
